import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Accounts from "./pages/Accounts";
import AddAccount from "./pages/AddAccount";
import Inquiries from "./pages/Inquiries";
import RefreshLogs from "./pages/RefreshLogs";
import IdentityCache from "./pages/IdentityCache";
import MobileCache from "./pages/MobileCache";
import Settings from "./pages/Settings";
import Backup from "./pages/Backup";
import AdminUsers from "./pages/AdminUsers";
import AdminInvoices from "./pages/AdminInvoices";
import PortalSettings from "./pages/PortalSettings";
import UserPanel from "./pages/UserPanel";
import AdminLayout from "./components/AdminLayout";
import { getToken, getRole } from "./lib/api";
import "./App.css";

// فقط کاربر واردشده (هر نقشی)
function RequireAuth({ children }) {
  if (!getToken()) return <Navigate to="/login" replace />;
  return children;
}

// فقط مدیر
function RequireAdmin({ children }) {
  if (!getToken()) return <Navigate to="/login" replace />;
  if (getRole() !== "admin") return <Navigate to="/panel" replace />;
  return children;
}

export default function App() {
  return (
    <BrowserRouter>
      <Toaster position="top-center" richColors closeButton dir="rtl" />
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/panel" element={<RequireAuth><UserPanel /></RequireAuth>} />
        <Route path="/" element={<RequireAdmin><AdminLayout /></RequireAdmin>}>
          <Route index element={<Dashboard />} />
          <Route path="accounts" element={<Accounts />} />
          <Route path="accounts/add" element={<AddAccount />} />
          <Route path="inquiries" element={<Inquiries />} />
          <Route path="refresh-logs" element={<RefreshLogs />} />
          <Route path="identity-cache" element={<IdentityCache />} />
          <Route path="mobile-cache" element={<MobileCache />} />
          <Route path="users" element={<AdminUsers />} />
          <Route path="invoices" element={<AdminInvoices />} />
          <Route path="portal-settings" element={<PortalSettings />} />
          <Route path="backup" element={<Backup />} />
          <Route path="settings" element={<Settings />} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
